const getParams = object => {
  return `?${Object.keys(object)
    .filter(key => !!object[key])
    .map(key => `${key}=${encodeURIComponent(object[key])}`)
    .join('&')}`
}

export const buildLinkedinLink = url => {
  return `https://linkedin.com/shareArticle${getParams({
    mini: true,
    url: url,
  })}`
}
